export default __webpack_public_path__ + "4a43d239ea673e226e1dd2e9588fb452.svg";